import { confirmDiscardText, confirmDiscardSubText } from './discardCompose.locstring.json';
import loc from 'owa-localize';
import closeCompose from '../actions/closeCompose';
import datapoints from '../datapoints';
import { ClientItem } from 'owa-mail-store';
import { setSmartPillClickStatus } from 'owa-mail-store-actions';
import mailStore from 'owa-mail-store/lib/store/Store';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import { uiLessAddinIsRunning } from '../utils/blockOnNavigation';
import { ComposeScenario, logSmartReplyDatapoint } from '../utils/logSmartReplyComposeDatapoint';
import safelyGetSmartReplyExtractionId from '../utils/safelyGetSmartReplyExtractionId';
import { isViewStateDirty } from '../utils/viewStateUtils';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import endSession from 'owa-controls-findpeople-feedback-manager/lib/actions/endSession';
import deleteItemService from 'owa-mail-store/lib/services/deleteItemService';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { logDiscardActionMailTipsDatapoint } from 'owa-mail-tips/lib/datapoints';
import { getAllRecipients } from '../utils/getAllRecipientsAsEmailAddressStrings';
import getMailTipsViewStateMap from '../utils/getMailTipsViewStateMap';

function deleteDraft(viewState: ComposeViewState) {
    if (viewState && viewState.itemId) {
        const deleteType =
            viewState.operation == ComposeOperation.EditDraft || viewState.isManuallySaved
                ? 'MoveToDeletedItems'
                : 'HardDelete';
        deleteItemService([viewState.itemId], deleteType);
    }

    endSession(viewState.findPeopleFeedbackManager, 'Discard');
    closeCompose(viewState);
}

/**
 * Currently there is no good way to check if the compose session is triggered via
 * Smart Reply. We need a better way to track actions between RP and Compose (WI:#58242)
 * */
function resetSmartPillsVisibility(viewState: ComposeViewState) {
    if (viewState && viewState.referenceItemId) {
        const refItemId = viewState.referenceItemId;
        if (refItemId) {
            const item: ClientItem = mailStore.items.get(refItemId.Id) as ClientItem;
            // Only update the property if it's dirty
            if (item && item.isSmartPillClicked) {
                setSmartPillClickStatus(refItemId, false);
            }
        }
    }
}

export const shouldShowDiscardConfirmDialog = (viewState: ComposeViewState) =>
    isViewStateDirty(viewState) ||
    uiLessAddinIsRunning(viewState) ||
    (viewState.itemId &&
        (viewState.operation == ComposeOperation.EditDraft || viewState.lastSaveTimeStamp != null));

export default createLegacyActionWithDatapoint(
    'discardCompose',
    datapoints.ComposeCommandDiscardCompose
)(function discardCompose(viewState: ComposeViewState, doNotConfirm?: boolean) {
    // No need to show confirm dialog when the viewState is not dirty and
    // (No draft created for this viewState, or draft is never saved since created),
    // Or there is no running uiless add-in
    const resolveImmediately = doNotConfirm || !shouldShowDiscardConfirmDialog(viewState);

    return confirm(loc(confirmDiscardText), loc(confirmDiscardSubText), resolveImmediately, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then((response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            logDiscardActionMailTipsDatapoint(
                getMailTipsViewStateMap(viewState.ccRecipientWell, getAllRecipients(viewState))
            );
            deleteDraft(viewState);
        }

        // If we are discarding a message created via smart reply, log a datapoint.
        logSmartReplyDatapoint(ComposeScenario.Discard, safelyGetSmartReplyExtractionId(viewState));

        resetSmartPillsVisibility(viewState);
    });
});
